var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.479004,
    width: 29.4085,
    height: 29,
    rx: 5,
    fill: "#43AC43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3708 8.99637C11.1803 8.75487 10.8183 8.73265 10.5989 8.94898L9.81256 9.72442C9.44485 10.087 9.30967 10.6007 9.47033 11.0514C10.1155 12.8609 11.1717 14.56 12.6401 16.008C14.1084 17.4559 15.8314 18.4975 17.6665 19.1337C18.1234 19.2921 18.6444 19.1588 19.0121 18.7962L19.7985 18.0207C20.0178 17.8044 19.9953 17.4474 19.7504 17.2596L17.9964 15.9143C17.8713 15.8184 17.7084 15.7845 17.5546 15.8224L15.8897 16.2328C15.4375 16.3443 14.9591 16.2136 14.6295 15.8886L12.7611 14.0462C12.4315 13.7211 12.299 13.2494 12.412 12.8034L12.8283 11.1616C12.8667 11.01 12.8323 10.8494 12.735 10.726L11.3708 8.99637ZM10.0253 8.38331C10.5897 7.82672 11.5211 7.8839 12.0112 8.50523L13.3754 10.2349C13.6257 10.5523 13.7142 10.9656 13.6153 11.3557L13.1991 12.9975C13.1551 13.1708 13.2066 13.3542 13.3347 13.4805L15.2031 15.3229C15.3312 15.4493 15.5172 15.5 15.693 15.4567L17.3579 15.0463C17.7535 14.9487 18.1726 15.036 18.4945 15.2829L20.2485 16.6281C20.8785 17.1114 20.9365 18.0298 20.3721 18.5864L19.5857 19.3619C19.0231 19.9167 18.1816 20.1603 17.3974 19.8884C15.4502 19.2133 13.6225 18.1081 12.0664 16.5736C10.5104 15.0392 9.38959 13.2368 8.705 11.3167C8.42928 10.5433 8.67632 9.71354 9.23892 9.15875L10.0253 8.38331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallTableIcon);
export default __webpack_public_path__ + "static/media/call-table-icon.756bd2145052a821fb89254a9a26acc0.svg";
export { ForwardRef as ReactComponent };